import { SVGProps } from 'react'

export const Settings = ({
  size = 24,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.075 2H10.6736L10.451 2.33397L8.88852 4.67764L6.38739 4.10046L5.98235 4.00699L5.68842 4.30092L4.30092 5.68842L4.00699 5.98235L4.10046 6.38739L4.67764 8.88852L2.33397 10.451L2 10.6736V11.075V12.925V13.3264L2.33397 13.549L4.67764 15.1115L4.10046 17.6126L4.00698 18.0176L4.30092 18.3115L5.68842 19.699L5.98235 19.993L6.38738 19.8995L8.88851 19.3224L10.451 21.666L10.6736 22H11.075H12.925H13.3264L13.549 21.666L15.1115 19.3224L17.6126 19.8995L18.0176 19.993L18.3115 19.699L19.699 18.3115L19.993 18.0176L19.8995 17.6126L19.3224 15.1115L21.666 13.549L22 13.3264V12.925V11.075V10.6736L21.666 10.451L19.3224 8.88851L19.8995 6.38738L19.993 5.98235L19.699 5.68842L18.3115 4.30092L18.0176 4.00698L17.6126 4.10046L15.1115 4.67764L13.549 2.33397L13.3264 2H12.925H11.075ZM9.84904 5.94103L11.4764 3.5H12.5236L14.151 5.94103L14.4385 6.37236L14.9436 6.25579L17.5448 5.65552L18.3444 6.45515L17.7442 9.05637L17.6276 9.56149L18.059 9.84904L20.5 11.4764V12.5236L18.059 14.151L17.6276 14.4385L17.7442 14.9436L18.3444 17.5448L17.5448 18.3444L14.9436 17.7442L14.4385 17.6276L14.151 18.059L12.5236 20.5H11.4764L9.84904 18.059L9.56149 17.6276L9.05637 17.7442L6.45515 18.3444L5.65552 17.5448L6.25579 14.9436L6.37236 14.4385L5.94103 14.151L3.5 12.5236V11.4764L5.94103 9.84904L6.37236 9.56148L6.25579 9.05636L5.65551 6.45515L6.45515 5.65551L9.05636 6.25579L9.56148 6.37236L9.84904 5.94103ZM10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12ZM12 8.5C10.067 8.5 8.5 10.067 8.5 12C8.5 13.933 10.067 15.5 12 15.5C13.933 15.5 15.5 13.933 15.5 12C15.5 10.067 13.933 8.5 12 8.5Z"
      fill="currentColor"
    />
  </svg>
)

